<app-widget-home-core
  [widget]="widget"
  [isStoreView]="isStoreView"
  [subheader]="local"
  (click)="onClickWidget()"
>

  <ion-list class="widget-data-list">

    @if (loadedData || isStoreView) {

      @for (communication of widgetData | slice: 0: 3; track communication.id) {

        <app-communication-item
          class="yu-item"
          [communication]="communication"
        ></app-communication-item>

      } @empty {

        <app-empty-item
          [detailEmpty]="true"
          [title]="'WIDGETS.HOME.COMMUNICATION.NO_UNREAD_COMMUNICATIONS' | translate"
        ></app-empty-item>

      }

    } @else {

      <ion-skeleton-text animated></ion-skeleton-text>

    }

  </ion-list>

</app-widget-home-core>
